import { createContext, useContext } from 'react';
import type { AuthSession, PermissionCode, SessionInfo } from '../types';

export interface AuthContextValue {
  session: SessionInfo | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  switchWorkspace: (workspaceId: string) => Promise<void>;
  /** Entra com uma sessão já emitida (aceite de convite). */
  startSession: (auth: AuthSession) => void;
  /** Relê /auth/me — depois de mudar nome, logo ou papéis. */
  refreshSession: () => Promise<void>;
  /** Administrador passa sempre; os demais precisam de um dos códigos. */
  can: (...codes: PermissionCode[]) => boolean;
  isAdmin: boolean;
}

/**
 * Contexto e hook moram fora do arquivo do provider: um módulo que exporta
 * componente e não-componente juntos quebra o fast refresh do Vite.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth precisa estar dentro de <AuthProvider>');
  return context;
}
